import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 新增站点
 */
export const SiteAdd = data => {
  return request('POST', `${baseUrl}/api/auth/sys/station/add`, data);
};

/**
 * 删除站点
 */
export const SiteDelete = data => {
  return request('POST', `${baseUrl}/api/auth/sys/station/del`, data);
};

/**
 * 站点详情
 */
export const SiteDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/detail`, params);
};

/**
 * 停用站点
 */
export const SiteDisable = data => {
  return request('POST', `${baseUrl}/api/auth/sys/station/disable`, data);
};

/**
 * 启用站点
 * @param {*} data
 * @returns
 */

export const SiteEnable = data => {
  return request('POST', `${baseUrl}/api/auth/sys/station/enable`, data);
};

/**
 * 编辑站点
 */
export const SiteEdit = data => {
  return request('POST', `${baseUrl}/api/auth/sys/station/edit`, data);
};

/**
 * 站点管理列表
 */
export const SiteList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page`, params);
};

/**
 * 所属站点
 */
export const SiteSelect = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/select`, params);
};

/**
 * 站点搜索
 */
export const SiteQuery = params => {
  return request('GET', `${baseUrl}/api/auth/home/station/query`, params);
};

/**
 * 异步查询站点状态
 */
export const SiteQueryStatus = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/async/list`, params);
};

/**
 * 统计站点下面模型的数量
 */
export const SiteModelCount = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/model/devs`, params);
};

/**
 * 获取站点下的状态统计
 */
export const SiteStatus = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/dev/history`, params);
};

/**
 * 获取流量平台列表接口
 */
export const SiteTrafficPlatform = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/traffic/platforms`, params);
};

/**
 * 获取设备流量统计
 */
export const SiteTrafficDevice = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/traffic/dev`, params);
};

/**
 * 累计流量统计
 */
export const SiteTrafficTotal = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/traffic/total`, params);
};

/**
 * 获取站点下的用户列表
 */
export const SiteUsers = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/msg/user/list`, params);
};

/**
 * 获取当前站点的设备列表
 */
export const SiteDevices = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/dev/list`, params);
};

/**
 * 当前告警
 */
export const SiteAlarmsCurrent = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page/alarm/current`, params);
};

/**
 * 历史告警
 */
export const SiteAlarmsHistory = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page/alarm/history`, params);
};

/**
 * 站点编辑事件
 */
export const SiteEventEdit = data => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page/event/operator`, data);
};

/**
 * 设备编辑事件
 */
export const DeviceEventEdit = data => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page/event/dev/operator`, data);
};

/**
 * 设备控制事件
 */
export const DeviceEventControl = data => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page/event/dev/ctrl`, data);
};

/**
 * 设备配置事件
 */
export const DeviceEventConfig = data => {
  return request('GET', `${baseUrl}/api/auth/sys/station/page/event/dev/pc`, data);
};

/**
 * 获取当前站点（客户）下的所有可通知的用户列表
 */
export const SiteNotifyUsers = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/msg/user/all`, params);
};

/**
 * 获取当前站点下的所有设备模型控制类型
 */
export const SiteAllDevices = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/model/ctrl/all`, params);
};

// /station/stat/model/devs
export const SiteAllModelList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/station/stat/model/devs`, params);
};
